import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component'
import { AuthService } from '../../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
} from '../../../core/models/contact-type.model'
import { MatButton } from '@angular/material/button'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { ProposalClientEditComponent } from '../../../features/proposal/proposal-client-edit/proposal-client-edit.component'
import { PurchasesQuoteRequestService } from '../../../core/services/purchases/purchases-quote-request/purchases-quote-request.service'
import { PurchasesQuoteRequestCreateComponent } from '../../../features/purchases/purchases-quote-request/purchases-quote-request-create/purchases-quote-request-create.component'
import { TableListTariffComponent } from '../../../shared/components/table-list-tariff/table-list-tariff.component'
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator'
import { MatTabsModule } from '@angular/material/tabs'
import { ModalPurchasesRequestItinerariesComponent } from '../../../features/purchases/purchases-quote-request/modal-purchases-request-itineraries/modal-purchases-request-itineraries.component'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatOptionModule } from '@angular/material/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms'
import { JsonPipe } from '@angular/common'
import { FormSearchQuoteTgComponent } from '../../../shared/components/form-search-quote-tg/form-search-quote-tg.component'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import { TableListPurchasesQuoteSupplierPageComponent } from '../../../shared/components/table-list-purchases-quote-supplier-page/table-list-purchases-quote-supplier-page.component'
import { FormSearchQuoteRequestTgComponent } from '../../../shared/components/form-search-quote-request-tg/form-search-quote-request-tg.component'
import { FormSearchQuoteRequestTgNewComponent } from '../../../shared/components/form-search-quote-request-tg-new/form-search-quote-request-tg-new.component'
import { PurchasesQuoteRequestCreateNewComponent } from '../../../features/purchases/purchases-quote-request/purchases-quote-request-create-new/purchases-quote-request-create-new.component'

@Component({
  selector: 'purchases-quote-request',
  imports: [
    MatProgressBar,
    PaginationComponent,
    MatButton,
    TableListTariffComponent,
    MatPaginatorModule,
    MatTabsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOptionModule,
    FormsModule,
    ReactiveFormsModule,
    JsonPipe,
    FormSearchQuoteTgComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    TableListPurchasesQuoteSupplierPageComponent,
    FormSearchQuoteRequestTgComponent,
    FormSearchQuoteRequestTgNewComponent,
  ],
  templateUrl: './purchases-quote-request.component.html',
  styleUrl: './purchases-quote-request.component.scss',
  providers: [ProposalClientService, AuthService],
  standalone: true,
})
export class PurchasesQuoteRequestComponent implements OnInit {
  constructor(
    private purchasesQuoteRequestService: PurchasesQuoteRequestService,
    private proposalClientService: ProposalClientService,
    private authService: AuthService,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
  ) {}

  form: FormGroup = new FormGroup({})

  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  listStatus: any[] = []
  loading = false
  columns: any[] = [
    {
      keyColumn: 'tgcod',
      key: 'tg',
      description: 'tg cod.',
    },
    {
      keyColumn: 'event',
      key: 'nomeEvento',
      description: 'Evento',
    },
    {
      keyColumn: 'custumerPurchase',
      key: 'nomeClient',
      description: 'Cliente / Subcliente',
    },
    {
      keyColumn: 'consultant',
      key: 'nomeConsultor',
      description: 'Solicitante',
    },
    {
      keyColumn: 'consultantCommercial',
      key: 'consultorComercial',
      description: 'Consultor Comercial',
    },
    // {
    //   keyColumn: 'event_tgCod',
    //   key: 'tg_info',
    //   description: 'Proposta',
    // },
    // {
    //   keyColumn: 'pageTariffLocation',
    //   // keyColumn: 'location_OD',
    //   key: 'origem',
    //   description: 'Trecho',
    // },
    // {
    //   keyColumn: 'servico_TS',
    //   key: 'tipoServico',
    //   description: 'Serviço',
    // },
    // {
    //   keyColumn: 'vehicle_VM',
    //   key: 'tipoVeiculo',
    //   description: 'Veículo',
    // },
    // {
    //   keyColumn: 'pageDate',
    //   key: 'origem',
    //   description: 'Data',
    // },
    // {
    //   keyColumn: 'status',
    //   key: 'descricaoStatus',
    //   description: 'Status',
    // },
    {
      keyColumn: 'action',
      key: {
        edit: false,
        delete: false,
        download: false,
        select: true,
        sendContract: false,
        sendEmail: false,
        sendItineraries: false,
      },
      description: 'Ações',
    },
  ]

  screen = 'compras'

  listSearch: any = [
    {
      id: 'nomeFantasia',
      description: 'Nome Fantasia',
      type: 'string',
      visible: true,
    },
    // { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    {
      id: 'razaoSocial',
      description: 'Razão Social',
      type: 'string',
      visible: true,
    },
    { id: 'cnpj', description: 'Cnpj', type: 'string', visible: true },
    {
      id: 'inscricaoEstadual',
      description: 'Insc. Estadual',
      type: 'string',
      visible: false,
    },
    {
      id: 'inscricaoMunicipal',
      description: 'Insc. Munucipal',
      type: 'string',
      visible: false,
    },
  ]

  searchForm: any = { search: false, model: {} }
  inputSearch = ''

  ngOnInit() {
    this.createForm()
    this.checkColumnAction()
    // this.getListItems()
    // this.getListSearchStatus()
    // this.listAllRequestStatus()
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        delete: this.checkPermission('deletar'),
        download: false,
        select: true,
        sendItineraries: false,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      statusSelected: [1],
    })
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }
  //
  // pageChanged(page: number) {
  //   this.page = page
  //   this.uploadList()
  // }
  //
  // uploadList(search: string = '') {
  //   if (search == 'new') {
  //     this.searchForm = new SearchContactTypeModel()
  //   }
  //   if (this.searchForm.descricao) {
  //     this.searchListItems()
  //   } else {
  //     // this.getListItems()
  //     this.getListSearchStatus()
  //   }
  // }

  search(event: any) {
    this.page = 1
    this.searchForm = event
    if (event.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
  }

  uploadList(type = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          // tipoServico: item.descricaoTipoServico,
          // servico: item.descricaoServico,
          // tipoVeiculo: item.descricaoTipoVeiculo,
          // tipoMotorista: item.descricaoTipoMotorista,
        })
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.purchasesQuoteRequestService
      .listPagedPurchasesQuoteRequestOpen(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  getListSearchStatus() {
    this.loading = true
    const statusId = {
      statusId:
        this.form.get('statusSelected')?.value != ''
          ? this.form.get('statusSelected')?.value
          : 5,
    }
    this.purchasesQuoteRequestService
      .listPagedSearchPurchasesStatus(this.page, this.rows, statusId)
      .subscribe({
        next: (res: any) => {
          if (res.data == null) {
            this.itemsList = []
          } else {
            this.treatResponse(res)
          }
          this.loading = false
        },
        error: (err) => {
          this.itemsList = []
          this.loading = false
        },
      })
  }

  onSelectionStatus(event: MatSelectChange) {
    this.page = 1
    // this.getListSearchStatus(event.value)
    this.uploadList('')
  }

  listAllRequestStatus() {
    this.purchasesQuoteRequestService.PurchaseRequestStatus().subscribe({
      next: (res: any) => {
        this.listStatus = res.data
        this.listStatus.reverse()
      },
      error: (err) => {
        this.listStatus = []
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.purchasesQuoteRequestService
      .searchPagedPurchasesQuoteRequestByProposal(
        // .searchPagedPurchasesQuoteRequest(
        this.page,
        this.rows,
        this.searchForm.model,
      )
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  newPriceQuote() {
    const dialogRef = this.dialog.open(PurchasesQuoteRequestCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList('')
      }
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(ProposalClientEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      if (response) {
        this.uploadList('')
      }
    })
  }

  downloadItem(item: any) {
    // Implementação do download
  }

  deleteItem(item: any) {
  }

  selectItemEvent(item: any) {
    const dialogRef = this.dialog.open(
      PurchasesQuoteRequestCreateNewComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '100vw',
        width: '100vw',
        maxHeight: '100vh',
        height: '100vh',
        panelClass: 'dialog-fullscreen',
        data: item,
      },
    )
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.uploadList('')
      }
    })
  }

  viewItinerariesEvent(item: any) {
    const dialogRef = this.dialog.open(
      ModalPurchasesRequestItinerariesComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        width: '1000px',
        maxWidth: '1000px',
        maxHeight: '620px',
        data: { item: item },
      },
    )
  }
}
